export default __webpack_public_path__ + "static/media/PipeChange.90a3e317.svg";